import { render } from "./WebOrders.vue?vue&type=template&id=25e17f8e"
import script from "./WebOrders.vue?vue&type=script&lang=js"
export * from "./WebOrders.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/WebOrders/WebOrders.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "25e17f8e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('25e17f8e', __exports__)) {
    api.reload('25e17f8e', __exports__)
  }
  
  module.hot.accept("./WebOrders.vue?vue&type=template&id=25e17f8e", () => {
    api.rerender('25e17f8e', render)
  })

}


export default __exports__